import { useCallback } from 'react';
import { PINNED_PRESET_ROUTE_PATH, usePinnedPresetRoutes } from '@/entities/settings';
import { useAppNavigate } from '@/shared/lib';

/**
 * Переводит список в раздел выбранного пресета: закреплённый пресет открывается по своему адресу,
 * незакреплённый и снятие пресета — по адресу обычного списка диалогов.
 *
 * Обратный ход (адрес применяет пресет) живёт на уровне страницы — `usePresetSectionSync`.
 *
 * @param tableName - Имя таблицы (например, `'dialogsListV2'`).
 */
export const usePresetRoute = (tableName: string) => {
  const navigate = useAppNavigate();
  const pinnedRoutes = usePinnedPresetRoutes(tableName);

  const onActivePresetChange = useCallback(
    (presetId: string | null) => {
      const targetRoute = presetId ? pinnedRoutes.find((route) => route.preset.id === presetId) : undefined;
      if (targetRoute) {
        navigate(PINNED_PRESET_ROUTE_PATH, { slug: targetRoute.slug, id: null });
        return;
      }
      navigate('/dialogs/:id?', { id: null });
    },
    [pinnedRoutes, navigate],
  );

  return { onActivePresetChange };
};
